const state = {
  /** 1 = delivery, 2 = retira, -1 = aún no definido (checkout recién carga) */
  formaEntrega: -1,
  /** Switch: programar horario para hoy */
  horarioDistinto: false,
  /** Hora elegida "HH:mm" o null */
  horaProgramada: null
}

const mutations = {
  setFormaEntrega (s, v) {
    s.formaEntrega = v != null ? v : -1
  },
  setHorarioDistinto (s, v) {
    s.horarioDistinto = !!v
    if (!s.horarioDistinto) s.horaProgramada = null
  },
  setHoraProgramada (s, v) {
    s.horaProgramada = v || null
  },
  resetHorarioProgramado (s) {
    s.horarioDistinto = false
    s.horaProgramada = null
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
